import { WorkScheduleRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * workScheduleOnSaveData - Function that saves on database a new work schedule
 * /work-schedules
 * method POST
 * @async-function
 */
const workScheduleOnSaveData = async (token: string, model: WorkScheduleRequestType) => {
    const response = await api.post(
        `/work-schedules`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default workScheduleOnSaveData;
